import React, { useEffect, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import WebSite from "./WebSite";
import Loader from "./Components/Loader";

// 1) Attendre que la page et les ressources de l'écran initial soient prêtes
function waitForWindowLoad() {
  return new Promise((resolve) => {
    if (document.readyState === "complete") return resolve();
    const onLoad = () => { window.removeEventListener("load", onLoad); resolve(); };
    window.addEventListener("load", onLoad, { once: true });
  });
}

// 2) Précharger Home.js
function preloadRoutes() {
  const routes = [
    () => import("./Pages/Home")
  ];
  return Promise.allSettled(routes.map(load => load()));
}

// 3) précharger quelques assets
function preloadAssets(urls = []) {
  if (!urls.length) return Promise.resolve();
  return Promise.allSettled(
    urls.map(
      (src) =>
        new Promise((resolve) => {
          const img = new Image();
          img.onload = img.onerror = resolve;
          img.src = src;
        })
    )
  );
}

// 4) Timeout de sécurité (ne pas bloquer indéfiniment)
function withTimeout(promise, ms = 8000) {
  return new Promise((resolve) => {
    const t = setTimeout(resolve, ms);
    promise.finally(() => clearTimeout(t)).then(() => resolve());
  });
}

export default function App() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    (async () => {
      await withTimeout(
        Promise.all([
          waitForWindowLoad(),     // DOM + ressources initiales
          preloadRoutes(),         // charge toutes les pages
          preloadAssets([
            // "/images/hero.jpg", "/images/section1.png"  <-- optionnel
          ])
        ])
      );
      setReady(true);
    })();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <WebSite />
      </BrowserRouter>

      {/* Loader overlay : masque tout tant que ready === false */}
      <Loader ready={ready} minDuration={800} />
    </div>
  );
}
